import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type User } from '@avanta/shared/types/users';
import { useTranslation } from 'react-i18next';
import { PatientCard, type PatientCardPatient } from '../PatientCard';
import { PatientCardSkeleton } from '../PatientCardSkeleton';

interface PatientSearchResultsProps {
  patients: User[] | undefined;
  isLoading: boolean;
  showEmptyState: boolean;
  onPatientSelect: (patient: PatientCardPatient) => void;
}

export const PatientSearchResults = ({
  patients,
  isLoading,
  showEmptyState,
  onPatientSelect,
}: PatientSearchResultsProps): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  if (isLoading) return <PatientCardSkeleton />;

  if (showEmptyState) {
    return (
      <Text variant="text-sm-regular" className="text-denim-500">
        {t('AppointmentsReserve.SearchPatient.notFound')}
      </Text>
    );
  }

  if (!patients?.length) return null;

  return (
    <>
      {patients.map(patient => (
        <PatientCard key={patient.id} patient={patient} onSelect={onPatientSelect} />
      ))}
    </>
  );
};
